export default class FacilityUserAssignment {

  id = "";

  users = "";
  userName = "";
  facility = "";
  facilityName = "";
  role = "";
  roleName = "";

  rank = "";
  roleConfirmed = false;

  constructor() {
  }
}
